export type AskAiTier = 'off' | 'askai-lite' | 'askai-full';

export const defaultOpenAIAnswer = 'Here are some references to check out:';
export const customDefaultAnswer = "Ask AI didn't have an answer for this question.";
export const DOCUMENT_SUMMARY_MODEL = 'gpt-4o';
export const DEFAULT_OWLBOT_MODEL = 'gemini-3.1-pro-preview';

export const didOwlbotAnswer = (givenAnswer: string, projectDefaultAnswer: string): boolean =>
  givenAnswer !== (projectDefaultAnswer || defaultOpenAIAnswer);

export interface GetAskAiTierParams {
  /** God-mode override. */
  askAiOverride?: AskAiTier | '';
  /** Single enterprise, child enterprise, or non-enterprise. */
  enterpriseStatus: 'child' | 'single' | 'none';
  /** Has AskAI booster pack purchased. */
  hasBoosterPack: boolean;
  /** `hideAiFeatures` flag — hard-off everywhere. */
  hideAiFeatures?: boolean;
  /** On active project trial AND opted into the AskAI trial upgrade. */
  isAskAiFullTrial: boolean;
  /** Project is on free plan,not activated, and is on a non-expired trial. */
  isProjectTrial: boolean;
  /** Parent project's `flags.askAiOverride`. */
  parentAskAiOverride?: AskAiTier | '';
  /** Plan permission grants AskAI Lite. */
  planHasAskAi: boolean;
}

export * from './chatAgent';

export function getAskAiTier({
  enterpriseStatus,
  askAiOverride,
  parentAskAiOverride,
  hasBoosterPack,
  isAskAiFullTrial,
  isProjectTrial,
  planHasAskAi,
  hideAiFeatures,
}: GetAskAiTierParams): AskAiTier {
  if (hideAiFeatures) return 'off';

  if (enterpriseStatus === 'child') {
    if (askAiOverride) return askAiOverride;
    if (hasBoosterPack) return 'askai-full';
    if (parentAskAiOverride) return parentAskAiOverride;
    return planHasAskAi ? 'askai-lite' : 'off';
  }

  if (enterpriseStatus === 'single') {
    if (askAiOverride) return askAiOverride;
    if (hasBoosterPack) return 'askai-full';
    return planHasAskAi ? 'askai-lite' : 'off';
  }

  // Non-enterprise
  if (askAiOverride) return askAiOverride;
  if (hasBoosterPack || isAskAiFullTrial) return 'askai-full';
  if (isProjectTrial || planHasAskAi) return 'askai-lite';
  return 'off';
}
